import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.updateWebdocMeeting.label",
    defaultMessage: "Change",
    description: "change button label",
  },
});
